import {
  START_DIABETES_BRANCH,
  START_DIABETES_WORKSHOP_BRANCH,
  START_POINTS_BRANCH,
  START_POINTS_WORKSHOP_BRANCH
} from "../config/tags";

export const isUserOnProgramBranch = (answers, questions) => {
  const question =
    questions.find(q => q.tags.includes(START_POINTS_BRANCH)) || {};
  const questionWorkshop =
    questions.find(q => q.tags.includes(START_POINTS_WORKSHOP_BRANCH)) || {};
  return !!answers.find(
    a => a.questionId === question._id || a.questionId === questionWorkshop._id
  );
};

export const isUserOnDiabetesBranch = (answers, questions) => {
  const question =
    questions.find(q => q.tags.includes(START_DIABETES_BRANCH)) || {};
  const questionWorkshop =
    questions.find(q => q.tags.includes(START_DIABETES_WORKSHOP_BRANCH)) || {};
  return !!answers.find(
    a => a.questionId === question._id || a.questionId === questionWorkshop._id
  );
};
